import { Target, TrendingUp, Trophy } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/Reveal";

const CARDS = [
  {
    icon: Target,
    title: "High School & Travel Ball Stars",
    desc: "Athletes chasing D1 offers and draft-board attention who need elite physical preparation — not another generic team lift.",
  },
  {
    icon: TrendingUp,
    title: "College Baseball Players",
    desc: "Players who need more exit velo, more speed, and a body that holds up through a 56-game season and summer ball.",
  },
  {
    icon: Trophy,
    title: "Pro & Semi-Pro Athletes",
    desc: "Guys who demand professional-grade programming, honest feedback, and training that actually transfers to the field.",
  },
];

export default function WhoFor() {
  return (
    <section className="py-20 sm:py-28 lg:py-36" data-testid="who-this-is-for-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader index="01" label="Who This Is For" title="Built For Serious Players Only" />
        <Reveal delay={0.1}>
          <p className="max-w-2xl text-base sm:text-lg text-zinc-400 leading-relaxed mb-14">
            This is not a generic workout PDF or a mass-market app. It's
            individualized, 1-on-1 performance coaching for baseball players who
            are done guessing — and ready to train with intent.
          </p>
        </Reveal>
        <div className="grid gap-5 sm:gap-6 md:grid-cols-3">
          {CARDS.map((card, i) => (
            <Reveal key={card.title} delay={0.1 + i * 0.12}>
              <div
                className="group h-full bg-[#141416] border border-zinc-800 p-7 sm:p-9 hover:border-[#CCFF00]/50 transition-colors duration-300"
                data-testid={`who-for-card-${i}`}
              >
                <card.icon className="w-7 h-7 text-[#CCFF00] mb-8 transition-transform duration-300 group-hover:-translate-y-1" />
                <h3 className="font-display uppercase text-2xl sm:text-3xl tracking-wide text-white mb-4 leading-none">
                  {card.title}
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{card.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
